// extracted by mini-css-extract-plugin
export default {"sidebarnavigator":"bb462681243bed2aec56","sidebar":"d3f9c7b0b97c8ce0d2fc","container":"d36242ef0d5fb8ff7356"};